import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import whatsappIcon from '../../assets/whatsapp.png';

import './styles.css';

function PedidoWhatsapp() {
    const [openedAutomatically, setOpenedAutomatically] = useState(false);
    const orderData = useMemo(() => {
        try {
            return JSON.parse(sessionStorage.getItem('last_whatsapp_order') || '{}');
        } catch (error) {
            return {};
        }
    }, []);

    const whatsappUrl = orderData.whatsappUrl || '';

    const openWhatsapp = useCallback(() => {
        if (!whatsappUrl) {
            return;
        }

        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    }, [whatsappUrl]);

    useEffect(() => {
        if (!whatsappUrl || openedAutomatically) {
            return;
        }

        const timeout = setTimeout(() => {
            openWhatsapp();
            setOpenedAutomatically(true);
        }, 350);

        return () => clearTimeout(timeout);
    }, [whatsappUrl, openedAutomatically, openWhatsapp]);

    return (
        <div id="order_complete_container">
            <header>
                <Link to="/">
                    Voltar ao menu
                    <FiChevronRight size={16}></FiChevronRight>
                </Link>
            </header>
            <main>
                <h1>Pedido criado com sucesso!</h1>
                <p>Estamos abrindo o WhatsApp em uma nova aba para você enviar a confirmação do pedido.</p>

                <div className="line" />

                <div className="field">
                    <h3>Cliente</h3>
                    <span>{orderData.nome || '-'}</span>
                </div>

                <div className="field">
                    <h3>Valor do Pedido</h3>
                    <span>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(orderData.totalValue || 0)}</span>
                </div>
                {!!orderData.pedido?.taxa_entrega && (
                    <div className="field">
                        <h3>Taxa de entrega</h3>
                        <span>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(orderData.pedido.taxa_entrega)}</span>
                    </div>
                )}

                <p>Caso o WhatsApp não abra automaticamente, toque no botão abaixo.</p>

                <button className="whatsapp_button" onClick={openWhatsapp} disabled={!whatsappUrl}>
                    Abrir WhatsApp
                    <img src={whatsappIcon} alt="Whatsapp" />
                </button>
            </main>
        </div>
    );
}

export default PedidoWhatsapp;
